export default {"src":"/_next/static/media/xem.b251b087.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};